import {PILL_CLASS} from './constants'


// True if `node` is a pill element (an HTMLElement carrying PILL_CLASS).
export function textareaWithVariables_isPillElement(node: Node): boolean {
    return node.nodeType === Node.ELEMENT_NODE
        && (node as HTMLElement).classList.contains(PILL_CLASS)
}
